/**
 * Hierarchical Permission System
 * Structure: Module > Section > Permission
 * Each permission can be individually toggled
 * Sections aggregate child permissions for bulk control
 */

export const PERMISSIONS_CONFIG = {
  modules: [
    {
      id: 'crm_module',
      name: 'Module: CRM',
      sections: [
        {
          id: 'customer_insights_section',
          name: 'Section: Customer Insights',
          permissions: [
            { key: 'customer_insights_view', label: 'Customer Insights View' },
            { key: 'customer_insights_modify', label: 'Customer Insights Modify' },
          ]
        },
        {
          id: 'customers_section',
          name: 'Section: Customers',
          permissions: [
            { key: 'entity_view_all', label: 'Entity View All' },
            { key: 'entity_view', label: 'Entity View' },
            { key: 'entity_modify', label: 'Entity Modify' },
            { key: 'client_view_all', label: 'Client View All' },
            { key: 'client_view', label: 'Client View' },
            { key: 'client_modify', label: 'Client Modify' },
          ]
        },
      ]
    },
    {
      id: 'policies_module',
      name: 'Module: Policies',
      sections: [
        {
          id: 'policy_section',
          name: 'Section: Policy',
          permissions: [
            { key: 'policy_view_all', label: 'Policy View All' },
            { key: 'policy_view', label: 'Policy View' },
            { key: 'policy_modify', label: 'Policy Modify' },
            { key: 'policy_menu_view', label: 'Policy Menu View' },
            { key: 'policy_delete', label: 'Policy Delete' },
            { key: 'policy_advisor_commission_split_view_all', label: 'Policy Advisor Commission Split View All' },
            { key: 'policy_advisor_commission_split_view', label: 'Policy Advisor Commission Split View' },
            { key: 'policy_advisor_commission_split_modify', label: 'Policy Advisor Commission Split Modify' },
            { key: 'policy_advisor_commission_split_delete', label: 'Policy Advisor Commission Split Delete' },
          ]
        },
        {
          id: 'policy_commission_report_section',
          name: 'Section: Policy Commission Report',
          permissions: [
            { key: 'policy_commission_report_view_all', label: 'Policy Commission Report View All' },
            { key: 'policy_commission_report_view', label: 'Policy Commission Report View' },
            { key: 'policy_commission_report_modify', label: 'Policy Commission Report Modify' },
            { key: 'policy_commission_report_delete', label: 'Policy Commission Report Delete' },
          ]
        },
        {
          id: 'policy_transaction_section',
          name: 'Section: PolicyTransaction',
          permissions: [
            { key: 'policy_transaction_view_all', label: 'Policy Transaction View All' },
            { key: 'policy_transaction_view', label: 'Policy Transaction View' },
            { key: 'policy_transaction_modify', label: 'Policy Transaction Modify' },
            { key: 'policy_transaction_delete', label: 'Policy Transaction Delete' },
          ]
        },
        {
          id: 'product_provider_section',
          name: 'Section: Product Provider',
          permissions: [
            { key: 'product_provider_view_all', label: 'Product Provider View All' },
            { key: 'product_provider_view', label: 'Product Provider View' },
            { key: 'product_provider_modify', label: 'Product Provider Modify' },
            { key: 'product_provider_delete', label: 'Product Provider Delete' },
          ]
        },
      ]
    },
    {
      id: 'commissions_module',
      name: 'Module: Commissions',
      sections: [
        {
          id: 'commissions_section',
          name: 'Section: Commissions',
          permissions: [
            { key: 'commissions_view_all', label: 'Commissions View All' },
            { key: 'commissions_view', label: 'Commissions View' },
            { key: 'commissions_modify', label: 'Commissions Modify' },
            { key: 'commissions_delete', label: 'Commissions Delete' },
          ]
        },
      ]
    },
    {
      id: 'attachments_module',
      name: 'Module: Attachments',
      sections: [
        {
          id: 'attachments_section',
          name: 'Section: Attachments',
          permissions: [
            { key: 'attachment_download', label: 'Attachment Download' },
            { key: 'attachment_delete', label: 'Attachment Delete' },
            { key: 'attachment_view', label: 'Attachment View' },
            { key: 'attachment_upload', label: 'Attachment Upload' },
          ]
        },
      ]
    },
    {
      id: 'settings_module',
      name: 'Module: Settings',
      sections: [
        {
          id: 'branches_section',
          name: 'Section: Branches, Warehouses and Areas',
          permissions: [
            { key: 'branches_view', label: 'Branches, Warehouses and Areas View' },
            { key: 'branches_modify', label: 'Branches, Warehouses and Areas Modify' },
            { key: 'branches_delete', label: 'Branches, Warehouses and Areas Delete' },
          ]
        },
        {
          id: 'sales_reps_section',
          name: 'Section: Sales Reps',
          permissions: [
            { key: 'sales_reps_view', label: 'Sales Reps View' },
            { key: 'sales_reps_modify', label: 'Sales Reps Modify' },
            { key: 'sales_reps_delete', label: 'Sales Rep Delete' },
          ]
        },
        {
          id: 'vat_rate_section',
          name: 'Section: VAT Rate',
          permissions: [
            { key: 'vat_rate_view', label: 'VAT Rate View' },
            { key: 'vat_rate_modify', label: 'VAT Rate Modify' },
            { key: 'vat_rate_delete', label: 'VAT Rate Delete' },
          ]
        },
      ]
    },
    {
      id: 'sales_module',
      name: 'Module: Sales',
      sections: [
        {
          id: 'sales_target_section',
          name: 'Section: Sales Target',
          permissions: [
            { key: 'sales_target_view', label: 'Sales Target View' },
            { key: 'sales_target_modify', label: 'Sales Target Modify' },
            { key: 'sales_target_delete', label: 'Sales Target Delete' },
          ]
        },
      ]
    },
    {
      id: 'data_visibility_module',
      name: 'Module: Data Visibility',
      sections: [
        {
          id: 'data_visibility_section',
          name: 'Section: Data Visibility Restrictions',
          permissions: [
            { key: 'can_view_advisor_commissions', label: 'Can View Advisor Commissions' },
            { key: 'can_view_all_clients', label: 'Can View All Clients' },
            { key: 'can_view_all_policies', label: 'Can View All Policies' },
            { key: 'can_view_communications', label: 'Can View Communications' },
          ]
        },
      ]
    },
    {
      id: 'admin_module',
      name: 'Module: Admin',
      sections: [
        {
          id: 'admin_section',
          name: 'Section: Admin',
          permissions: [
            { key: 'admin_view', label: 'Admin View' },
            { key: 'users_manage', label: 'Users Manage' },
            { key: 'roles_manage', label: 'Roles Manage' },
          ]
        },
      ]
    },
    {
      id: 'navigation_module',
      name: 'Module: Navigation (Page Access)',
      sections: [
        {
          id: 'navigation_section',
          name: 'Section: Visible Pages',
          permissions: [
            { key: 'dashboard', label: 'Home / Dashboard' },
            { key: 'entities', label: 'Entities' },
            { key: 'clients', label: 'Clients' },
            { key: 'policies', label: 'Policies' },
            { key: 'commissions', label: 'Policy Transactions' },
            { key: 'commission_report', label: 'Commission Report' },
            { key: 'providers', label: 'Product Providers' },
            { key: 'tasks', label: 'Tasks' },
            { key: 'claims_tasks', label: 'Dispatch Claims' },
            { key: 'admin', label: 'Admin Section' },
            { key: 'users', label: 'Admin → Users' },
            { key: 'roles', label: 'Admin → Roles' },
          ]
        },
      ]
    },
  ]
}

/**
 * Helper function to flatten all permissions for easy lookup
 */
export function getAllPermissions() {
  const all = []
  PERMISSIONS_CONFIG.modules.forEach(module => {
    module.sections.forEach(section => {
      section.permissions.forEach(perm => {
        all.push({
          ...perm,
          moduleId: module.id,
          moduleName: module.name,
          sectionId: section.id,
          sectionName: section.name,
        })
      })
    })
  })
  return all
}

/**
 * Get all permission keys for a section
 */
export function getSectionPermissionKeys(sectionId) {
  const keys = []
  PERMISSIONS_CONFIG.modules.forEach(module => {
    const section = module.sections.find(s => s.id === sectionId)
    if (section) {
      section.permissions.forEach(perm => keys.push(perm.key))
    }
  })
  return keys
}

/**
 * Get all permission keys for a module
 */
export function getModulePermissionKeys(moduleId) {
  const keys = []
  const module = PERMISSIONS_CONFIG.modules.find(m => m.id === moduleId)
  if (module) {
    module.sections.forEach(section => {
      section.permissions.forEach(perm => keys.push(perm.key))
    })
  }
  return keys
}
